import { render, staticRenderFns } from "./ShippedPending.vue?vue&type=template&id=f01badf8"
import script from "./ShippedPending.vue?vue&type=script&lang=js"
export * from "./ShippedPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports